const table106 = [
    {
        key: "entity_code",
        name: "法人コード",
        editable: false
    },
    {
        key: "entity_name",
        name: "法人名",
        editable: false
    },
    {
        key: "before_previous_period_consolidated_begin",
        name: "前々期_事業年度(期首)",
        editable: true,
        type: "date"
    },
    {
        key: "before_previous_period_consolidated_end",
        name: "前々期_事業年度(期末)",
        editable: true,
        type: "date"
    },
    {
        key: "before_previous_period_outstanding_begin",
        name: "前々期_期首現在未決済額",
        editable: true
    },
    {
        key: "before_previous_period_outstanding_paid",
        name: "前々期_当期中の決済額_支払額",
        editable: true
    },
    {
        key: "before_previous_period_outstanding_receivable",
        name: "前々期_当期中の決済額_受取額",
        editable: true
    },
    {
        key: "year_begin",
        name: "前期_事業年度(期首)",
        editable: true,
        type: "date"
    },
    {
        key: "year_end",
        name: "前期_事業年度(期末)",
        editable: true,
        type: "date"
    },
    {
        key: "previous_period_begin_outstanding",
        name: "前期_期首現在未決済額",
        editable: true
    },
    {
        key: "previous_period_settlement_current_period_payment",
        name: "前期_当期中の決済額_支払額",
        editable: true
    },
    {
        key: "previous_period_settlement_current_period_receivable",
        name: "前期_当期中の決済額_受取額",
        editable: true
    },
    {
        key: "amount_occurred_current_period_additional_tax",
        name: "当期分_当期発生額_附帯税",
        editable: true
    },
    {
        key: "amount_occurred_current_period_payment",
        name: "当期分_当期発生額_中間",
        editable: true
    },
    {
        key: "consolidated_processed_loss",
        name: "当期分_当期発生額_損益通算分",
        editable: true
    },
    {
        key: "consolidated_processed_loss_parent",
        name: "当期分_当期発生額_非特定欠損金配賦額分",
        editable: true
    },
    {
        key: "consolidated_income",
        name: "当期分_当期発生額_試験研究費特別控除分",
        editable: true
    },
    {
        key: "consolidated_income_parent",
        name: "当期分_当期発生額_上記以外分",
        editable: true
    },
    {
        key: "settlement_payment_mid",
        name: "当期分_当期中の決済額_支払額_中間",
        editable: true
    },
    {
        key: "settlement_payment_mid_additional_tax",
        name: "当期分_当期中の決済額_支払額_中間_内附帯税",
        editable: true
    },
    {
        key: "settlement_payment_tax",
        name: "当期分_当期中の決済額_支払額_適格合併等",
        editable: true
    },
    {
        key: "settlement_payment_recievable",
        name: "当期分_当期中の決済額_受取額_中間",
        editable: true
    },
    {
        key: "settlement_receivable_tax",
        name: "当期分_当期中の決済額_受取額_適格合併等",
        editable: true
    }
];

export { table106 };
